//RITM1535076
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
    TextInput, Button, Checkbox, RadioButtonGroup, FormGroup, RadioButton, ComposedModal, ModalHeader, ModalBody, ModalFooter, TextArea
} from 'carbon-components-react';
import SimpleReactValidator from 'simple-react-validator';
import { ComboBox } from '../../../../helpers/ComboBox'
import { FindGHRSEmployer } from '../../../common/FindGHRSEmployer'
import { showNotification } from '../../../../helpers/notification/BaseNotification';
import { DateFormat, entitiesLabels } from '../../../../helpers/Constants';
import DateTimePicker from '../../../../helpers/DateTimePicker';
import _sortBy from "lodash/sortBy";
export default class ModalDrillPerson extends Component {
    initModalDrillPerson = (props) => {

        if (props.isEditModal) {
            return { ...props.editModel };
        }

        return {
            id: null,
            type: null,
            name: null,
            surname: null,
            email: '',
            position: null,
            badgeNumber: '',
            idEmployer: null,
            company: null,
            fullName: null,
        }
    }

    constructor(props) {
        super(props);
        this.validator = new SimpleReactValidator();
        this.state = {
            model: {
                ...this.initModalDrillPerson(props)
            },
            mode: props.mode || 0,
        };
    }

    handleChangeModel = (el) => {
        let inputName = el.target.name;
        let inputValue = el.target.value;
        let objName = el.target.alt;

        this.updateState(inputName, inputValue, objName);
    }

    handleChangeCombo = (inputName, selectedItem, objName) => {

        let inputValue = selectedItem ? selectedItem.id : null;
        let statusCopy = Object.assign({}, this.state.model);
        if (objName && objName != 'model')
            statusCopy[objName][inputName] = inputValue;
        else
            statusCopy[inputName] = inputValue;

        this.setState({ model: statusCopy });
    }

    updateState = (inputName, inputValue, objName) => {
        let statusCopy = Object.assign({}, this.state.model);
        if (objName && objName != 'model')
            statusCopy[objName][inputName] = inputValue;
        else
            statusCopy[inputName] = inputValue;

        this.setState({ model: statusCopy });
    }


    handleChangeMode = (m) => {
        this.setState({ mode: m })
    }

    setEmployer = (employer) => {
        if (employer && employer.id) {
            let statusCopy = Object.assign({}, this.state.model);
            statusCopy.idEmployer = employer.id;
            statusCopy.badgeNumber = employer.ghrS_ID;
            statusCopy.name = employer.name;
            statusCopy.surname = employer.surname;
            statusCopy.email = employer.email;
            statusCopy.position = employer.role;
            statusCopy.type = "Saipem";
            statusCopy.company = "Saipem";
            this.setState({ model: statusCopy, mode: 2 });
        }
    }

    save = () => {
        if (this.validator.allValid()) {
            const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (!this.state.model.email || re.test(String(this.state.model.email).toLowerCase())) {
                let dati = this.state.model;
                dati.fullName = ((dati.name !== null && dati.surname !== null)
                    ? dati.name.toUpperCase() + ' ' + dati.surname.toUpperCase()
                    : (dati.name == null && dati.surname !== null
                        ? dati.surname.toUpperCase()
                        : (dati.name !== null && dati.surname == null)
                            ? dati.name.toUpperCase()
                            : null));
                let personBadgeFound = !this.props.isEditModal ? (dati.badgeNumber !== '' && this.props.persons.find((el) => el.badgeNumber?.toLowerCase() == dati.badgeNumber?.toLowerCase()) ? true : false)
                    : (dati.badgeNumber !== '' && this.props.persons.find((el) => el.badgeNumber?.toLowerCase() == dati.badgeNumber?.toLowerCase() && el.id !== dati.id) ? true : false);
                let personMailFound = !this.props.isEditModal ? (dati.email !== '' && this.props.persons.find((el) => el.email?.toLowerCase() == dati.email?.toLowerCase()) ? true : false)
                    : (dati.email !== '' && this.props.persons.find((el) => el.email?.toLowerCase() == dati.email?.toLowerCase() && el.id !== dati.id) ? true : false);;
                let personNameFound = !this.props.isEditModal ? (this.props.persons.find((el) => (el.name.toLowerCase() + ' ' + el.surname.toLowerCase() == dati.name.toLowerCase() + ' ' + dati.surname.toLowerCase())) ? true : false)
                    : (this.props.persons.find((el) => (el.name.toLowerCase() + ' ' + el.surname.toLowerCase() == dati.name.toLowerCase() + ' ' + dati.surname.toLowerCase() && el.id !== dati.id) ? true : false));
                let personPositionFound = !this.props.isEditModal ? (this.props.persons.find((el) => el.position.toLowerCase() == dati.position.toLowerCase()) ? true : false)
                    : (this.props.persons.find((el) => el.position.toLowerCase() == dati.position.toLowerCase() && el.id !== dati.id) ? true : false);

                //controlli sull inserimento manuale di un utente già presente
                if (personPositionFound && (personBadgeFound || personMailFound || personNameFound)) {
                    showNotification.warning(`${entitiesLabels.WARNING}`, personBadgeFound ? ' drill participant already exists with Badge Number ' + dati.fullName + ' for Position :' + dati.position
                        : personMailFound ? ' drill participant already exists with Email ' + dati.email + ' for Position :' + dati.position
                            : ' drill participant already exists with Name ' + dati.fullName + ' for Position :' + dati.position);
                }
                else if (personBadgeFound) {
                    showNotification.warning(`${entitiesLabels.WARNING}`, ' drill participant already exists with Badge Number ' + dati.badgeNumber);
                }
                else if (personMailFound) {
                    showNotification.warning(`${entitiesLabels.WARNING}`, ' drill participant already exists with Email ' + dati.email);
                }
                else if (personNameFound) {
                    showNotification.warning(`${entitiesLabels.WARNING}`, ' drill participant already exists with Name ' + dati.fullName);
                }
                else {
                    this.props.save(dati);
                }
            }
            else {
                showNotification.warning(`${entitiesLabels.WARNING}`, entitiesLabels.EMERGENCYDRILL_PERSON + " email field not valid ");
            }
        } else {
            if (!this.validator.allValid()) {
                this.validator.showMessages();
                showNotification.warning(`${entitiesLabels.WARNING}`, entitiesLabels.EMERGENCYDRILL_PERSON + " required fields are missing  ");
                this.forceUpdate();
            }
        }
    }

    excludeOption(array, optionToExclude) {
        const filteredArray = [];
        const optionToExcludeArray = optionToExclude.split(',') || [];
        for (const item of array) {
            if (!optionToExcludeArray.some(o => o === item.id)) {
                filteredArray.push(item);
            }
        }
        return filteredArray;
    }
    render() {

        this.validator.purgeFields();
        const validations = {
            type: this.validator.message('type', this.state.model.idEmployer == null ? this.state.model.type : true, 'required'),
            name: this.validator.message('name', this.state.model.name, 'required'),
            surname: this.validator.message('surname', this.state.model.surname, 'required'),
            position: this.validator.message('position', this.state.model.position, 'required'),
            email: this.validator.message('email', this.state.model.email != null ? this.state.model.email : 'xxx@yyy.com', 'email'),
            company: this.validator.message('company', this.state.model.idEmployer == null ? this.state.model.company : true, 'required'),
        }
        const modalHeader = {
            title: (this.props.isEditModal ? 'Edit ' : 'Add new '),
            iconDescription: 'Close',
            buttonOnClick: () => this.props.toggleModal(false)
        };
        const { title, isOpenModal } = this.props;

        const appType = (this.props.appType || []).filter(
            (el) => (el.inUse) || this.state.model?.type == el.id);

        const selectedItemCombo = {
            type: (appType || []).find(el => el.id == this.state.model.type),
        };

        return (
            this.state.mode == 1 ?
                <FindGHRSEmployer isOpenModal={isOpenModal} onCancel={() => this.props.toggleModal(false)} onOk={this.setEmployer} participants={this.props.persons} />
                :
                <ComposedModal
                    className="light-modal"
                    open={isOpenModal}
                    danger="false"
                    onClose={() => { return false; }}
                >
                    <ModalHeader className="margin-modal" {...modalHeader} ><p>{title || ''}</p></ModalHeader>
                    <ModalBody className="margin-modal">
                        {
                            this.state.mode == 0 ?
                                <div className="bx--row two-button-center modal--elemnts-buttons" >
                                    <Button kind="primary" className="bx--col-md-6" onClick={() => this.handleChangeMode(1)}>
                                        Saipem research
                                    </Button>
                                    <Button kind='primary' className="bx--col-md-6" onClick={() => this.handleChangeMode(2)}>
                                        Manual input
                                    </Button>
                                </div>
                                :
                                <div className="bx--grid--full-width">
                                    <div className="bx--row row-content">
                                        <div className="bx--col-md-4 bx--col-lg-6">
                                            <FormGroup legendText={'Type' + (this.state.model.idEmployer == null ? "*" : "")}>
                                                <ComboBox
                                                    id="type"
                                                    key={`type${this.state.model.type}`}
                                                    placeholder="Select"
                                                    name="type"
                                                    alt="model"
                                                    onChange={this.handleChangeCombo}
                                                    itemToString={item => (item ? item.name : '')}
                                                    initialSelectedItem={selectedItemCombo.type}
                                                    items={appType ? this.state.model.idEmployer != null
                                                        ? appType.filter((item) => item.inUse && item.name === 'Saipem')
                                                        : this.excludeOption(appType, 'SAP,Saipem') : []}
                                                    disabled={this.state.model.idEmployer != null}
                                                    invalid={validations.type != null}
                                                />
                                                {validations.type}
                                            </FormGroup>
                                        </div>
                                        <div className="bx--col-md-4 bx--col-lg-6">
                                            <FormGroup legendText="Name*">
                                                <TextInput
                                                    id="txt-name"
                                                    name="name"
                                                    alt="model"
                                                    placeholder="Input name"
                                                    value={this.state.model.name || ''}
                                                    onChange={this.handleChangeModel}
                                                    type="text"
                                                    hideLabel={true}
                                                    labelText=""
                                                    disabled={this.state.model.idEmployer != null}
                                                    invalid={validations.name != null}
                                                />
                                                {validations.name}
                                            </FormGroup>
                                        </div>
                                        <div className="bx--col-md-4 bx--col-lg-6">
                                            <FormGroup legendText="Surname*">
                                                <TextInput
                                                    id="txt-surname"
                                                    name="surname"
                                                    alt="model"
                                                    placeholder="Input surname"
                                                    value={this.state.model.surname || ''}
                                                    onChange={this.handleChangeModel}
                                                    type="text"
                                                    hideLabel={true}
                                                    labelText=""
                                                    disabled={this.state.model.idEmployer != null}
                                                    invalid={validations.surname != null}
                                                />
                                                {validations.surname}
                                            </FormGroup>
                                        </div>
                                        <div className="bx--col-md-4 bx--col-lg-6">
                                            <FormGroup legendText="Email (Personal Email Addresses are not allowed)">
                                                <TextInput
                                                    id="txt-email"
                                                    name="email"
                                                    alt="model"
                                                    placeholder="Input email"
                                                    value={this.state.model.email || ''}
                                                    onChange={this.handleChangeModel}
                                                    type="text"
                                                    hideLabel={true}
                                                    labelText=""
                                                    title="&#9888; Do Not use Personal Accounts"
                                                    disabled={this.state.model.idEmployer != null}
                                                    invalid={validations.email != null}
                                                />
                                                {validations.email}
                                            </FormGroup>
                                        </div>
                                        <div className="bx--col-md-4 bx--col-lg-6">
                                            <FormGroup legendText="Badge number">
                                                <TextInput
                                                    id="badgeNumber"
                                                    name="badgeNumber"
                                                    alt="model"
                                                    placeholder="Input badge number"
                                                    value={this.state.model.badgeNumber || ''}
                                                    onChange={this.handleChangeModel}
                                                    type="text"
                                                    hideLabel={true}
                                                    labelText=""
                                                    disabled={this.state.model.idEmployer != null}
                                                />
                                            </FormGroup>
                                        </div>
                                        <div className="bx--col-md-4 bx--col-lg-6">
                                            <FormGroup legendText="Position*">
                                                <TextInput
                                                    id="txt-position"
                                                    name="position"
                                                    alt="model"
                                                    placeholder="Input position"
                                                    value={this.state.model.position || ''}
                                                    onChange={this.handleChangeModel}
                                                    type="text"
                                                    hideLabel={true}
                                                    labelText=""
                                                    disabled={this.state.model.idEmployer != null}
                                                    invalid={validations.position != null}
                                                />
                                                {validations.position}
                                            </FormGroup>
                                        </div>
                                        <div className="bx--col-md-4 bx--col-lg-6">
                                            <FormGroup legendText={'Company Name' + (this.state.model.idEmployer == null ? "*" : "")}>
                                                <TextInput
                                                    id="company"
                                                    name="company"
                                                    alt="model"
                                                    placeholder="Input Company Name"
                                                    value={this.state.model.company || ''}
                                                    onChange={this.handleChangeModel}
                                                    type="text"
                                                    hideLabel={true}
                                                    labelText=""
                                                    disabled={this.state.model.idEmployer != null}
                                                    invalid={validations.company != null}
                                                />
                                                {validations.company}
                                            </FormGroup>
                                        </div>
                                    </div>
                                </div>
                        }
                    </ModalBody>
                    <ModalFooter>
                        <Button kind="secondary" onClick={() => this.props.toggleModal(false)}>Cancel</Button>
                        <Button kind='primary' onClick={() => this.save()}>Save</Button>
                    </ModalFooter>
                </ComposedModal>
        );
    }
}
